export const zIndex = {
  banner: 700,
  dialog: 800,
  toast: 900,
} as const;

export type ZIndexKey = keyof typeof zIndex;
